var path = document.querySelector("meta[name='public-path']").content;
__webpack_public_path__ = path + "dist/";


// WEBPACK FOOTER //
// ./ui/public_path.js